import { MoneyConfig, MoneyHook, Theme, useMoney as useCoreMoney, useIsTheme } from '@afterpaytouch/core'
import { useCrossBorderTrade, useIsConsumerLendingOrder } from '../../state'

export const useMoney = (params: MoneyConfig): MoneyHook => {
  const { isCrossBorder } = useCrossBorderTrade()
  const isCashTheme = useIsTheme(Theme.Cash)
  const isConsumerLendingOrder = useIsConsumerLendingOrder()

  const currencyDisplay = isCrossBorder && isCashTheme && !isConsumerLendingOrder ? 'code' : 'symbol'
  return useCoreMoney({ ...params, currencyDisplay })
}
